// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export const StyledLabel = styled(Box)(({ theme, ownerState }) => {
    const filledVariant = ownerState.variant === 'filled';

    const outlinedVariant = ownerState.variant === 'outlined';

    const softVariant = ownerState.variant === 'soft';

    const defaultStyle = {
        ...(ownerState.color === 'default' && {
            // OUTLINED
            ...(outlinedVariant && {
                backgroundColor: 'transparent',
                color: theme.palette.text.primary,
                border: `1px solid ${theme.palette.border.input}`,
            }),
            // SOFT
            ...(softVariant && {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.action.selected,
            }),
        }),
    };

    const colorStyle = {
        ...(ownerState.color !== 'default' && {
            // FILLED
            ...(filledVariant && {
                color: theme.palette[ownerState.color].contrastText,
                backgroundColor: theme.palette[ownerState.color].main,
            }),
            // OUTLINED
            ...(outlinedVariant && {
                backgroundColor: 'transparent',
                color: theme.palette[ownerState.color].main,
                border: `1px solid ${theme.palette[ownerState.color].main}`,
            }),
            // SOFT — the pair is chosen per theme in the tokens, at 4.5:1 or
            // more in both.
            ...(softVariant && {
                color: theme.palette[ownerState.color].softText,
                backgroundColor: theme.palette[ownerState.color].soft,
            }),
        }),
    };

    return {
        // 24px at 12px type was a chip nearly as tall as a compact row.
        height: 22,
        minWidth: 22,
        borderRadius: theme.shape.borderRadius,
        cursor: 'default',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        justifyContent: 'center',
        padding: theme.spacing(0, 1),
        color: theme.palette.grey[800],
        fontFamily: theme.typography.fontFamily,
        ...theme.typography.label,
        lineHeight: 0,
        backgroundColor: theme.palette.grey[300],
        ...colorStyle,
        ...defaultStyle,
    };
});
